/* by Jeffrey Meng | MIT License */
//From :https://gist.github.com/jeffreymeng/78bd7f6b0f301fa5ef04359cd512222b
//Issue reference: https://github.com/alexluong/gatsby-packages/issues/21
//This is a hook that will give use firebase auth data on component mount
/* by Jeffrey Meng | MIT License */
import { useEffect, useReducer, useState } from "react";
import firebase from "gatsby-plugin-firebase";

interface FirebaseWithAuth {
  auth: () => firebase.auth.Auth;
}

export default function useAuthState(
  firebase: FirebaseWithAuth
): [firebase.User | undefined, boolean, firebase.auth.Error | undefined] {
  const [auth, setAuth] = useState<undefined | firebase.auth.Auth>(undefined);

  interface State {
    user: firebase.User | undefined;
    loading: boolean;
    error: firebase.auth.Error | undefined;
  }

  type Action =
    | { type: "auth_state_changed"; user: firebase.User }
    | { type: "error"; error: firebase.auth.Error };

  const [state, dispatch] = useReducer(
    (state: State, action: Action) => {
      switch (action.type) {
        case "auth_state_changed":
          return {
            ...state,
            user: action.user,
            loading: false,
          };
        case "error":
          return {
            ...state,
            error: action.error,
            loading: false,
          };
      }
    },
    {
      user: undefined,
      loading: true,
      error: undefined,
    }
  );
  useEffect(() => {
    setAuth(firebase.auth());
  }, [firebase]);

  useEffect(() => {
    if (auth === undefined) return;

    const unsubscribe = auth.onAuthStateChanged(
      (user): void => {
        dispatch({ type: "auth_state_changed", user });
      },
      (error: firebase.auth.Error): void => {
        dispatch({ type: "error", error });
      }
    );

    return (): void => {
      unsubscribe();
    };
  }, [auth]);
  return [state.user, state.loading, state.error];
}
